import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { DropdownContext } from '../Context';

export const DropdownButton = ({
  children,
  className,
  onClick,
  onKeyDown,
  activeClassName,
  ...props
}) => {
  const { dropdownState, setDropdownState, model } = useContext(
    DropdownContext
  );

  const isActive = dropdownState.model === model;

  const handleClick = e => {
    if (!isActive) {
      setDropdownState({ model });
    } else {
      document.activeElement.blur();
      setDropdownState({});
    }

    if (onClick) {
      onClick(e);
    }
  };

  return React.Children.map(children, child => {
    if (!child) {
      return child;
    }

    let combinedClassName = className || '';
    if (isActive && activeClassName) {
      combinedClassName += ` ${activeClassName}`;
    }

    return React.cloneElement(child, {
      ...props,
      onClick: handleClick,
      className: combinedClassName,
    });
  });
};

DropdownButton.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
};

DropdownButton.defaultProps = {
  className: null,
  activeClassName: null,
  onClick: null,
  onKeyDown: null,
};
